// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__367Nl","head":"ProcedureTableInfo_head__3sB6W"};